<template>
	<v-menu
		v-model="menu"
		offset-y
		bottom
		:left="toward === 'left'"
		:right="toward === 'right'"
		:close-on-content-click="false"
	>
		<template v-slot:activator="{ on }">
			<slot v-bind="on">
				<v-btn
					text
					class="px-0"
					color="white"
					aria-label="Toggle favorite properties"
					v-on="on"
				>
					<v-icon>mdi-cards-heart</v-icon><span>{{ favoriteList.length }}</span>
				</v-btn>
			</slot>
		</template>

		<v-card
			v-if="favoriteList.length > 0"
			:width="listWidth"
		>
			<v-list>
				<v-list-item>
					<v-list-item-content>
						Favorite list
					</v-list-item-content>

					<v-list-item-action>
						<n-link
							to="/favorites"
							@click.native="menu = false;"
						>
							ดูรายละเอียด
						</n-link>
					</v-list-item-action>
				</v-list-item>
			</v-list>

			<v-divider />

			<v-list class="fav-list">
				<favoriteListItem
					v-for="propId in favoriteList"
					:key="propId"
					:property="getProperty(propId)"
					:close="onCloseCallback"
				/>
			</v-list>
		</v-card>

		<v-card
			v-if="favoriteList.length === 0"
			width="300"
			height="200"
			class="boxFavorite"
		>
			ไม่มีรายการ
		</v-card>
	</v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import favoriteListItem from '~/components/favorite-list-item'

export default {
	components: {
		favoriteListItem
	},

	props: {
		toward: {
			type: String,
			default: 'left'
		},
		listWidth: {
			type: String,
			default: '300'
		}
	},

	data() {
		return {
			menu: false,
		}
	},

	computed: {
		...mapGetters({
			favoriteList: 'property/favoriteList',
			getProperty: 'property/getProperty'
		})
	},

	methods: {
		onCloseCallback (forceClose = false) {
			if (forceClose || this.favoriteList.length === 0) {
				this.menu = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.fav-list {
	max-height: 250px;
	overflow-y: auto;
}
.boxFavorite { color: rgb(255, 0, 0); padding: 10px 15px; }
</style>
